import { render, staticRenderFns } from "./config-preview.vue?vue&type=template&id=9c4f5882&"
import script from "./config-preview.vue?vue&type=script&lang=ts&"
export * from "./config-preview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports